import { CSSResultArray } from 'lit';
import host from '@maersk-global/mds-components-utils/host/host.styles.js';
import style from './mc-popover.scss';
import tokens from '@maersk-global/mds-design-tokens/implementation/core/popover/js/design-tokens-px.css.js';
export const styles: CSSResultArray = [host, style, tokens];
